export const copyToClipboardHandler = async (copyText: string): Promise<void> => {
    await navigator.clipboard.writeText(copyText)
}
